import React from "react";
import { useParams } from "react-router-dom";
import PageHeader from "../Ui_Components/PageHeader";
import UserDetailSection from "../client_details/component/User_Details_Section/UserDetailSection";
import AssignNutritionistTab from "./AssignNutritionistTab";
import useCustomScrollbar from "../styles/useCustomScrollbar";
import { Button } from "../Ui_Components/Button";

const SalesClientDetailPage: React.FC = () => {
  useCustomScrollbar();
  const { userId } = useParams<{ userId: string }>();

  if (!userId) {
    return (
      <div className="min-h-screen bg-[#F7F7FA] flex items-center justify-center">
        <div className="text-center">
          <p className="text-base text-red-500 mb-2">No valid user ID found in URL</p>
          <Button
            variant="primary"
            onClick={() => window.history.back()}
            className="mt-4"
          >
            Go Back
          </Button>
        </div>
      </div>
    );
  }

  const userIdNumber = parseInt(userId, 10);

  if (isNaN(userIdNumber)) {
    return (
      <div className="min-h-screen bg-[#F7F7FA] flex items-center justify-center">
        <div className="text-center">
          <p className="text-base text-red-500 mb-2">Invalid user ID format</p>
          <Button
            variant="primary"
            onClick={() => window.history.back()}
            className="mt-4"
          >
            Go Back
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-full flex flex-col bg-[#F7F7FA]">
      <PageHeader
        title="Client details"
        breadcrumb="Clients > Client details"
        breadcrumbLinks={["/sales-clients", ""]}
      />
      <UserDetailSection userId={userIdNumber} hidePlansButton={true} />
      <div className="flex-1">
        <AssignNutritionistTab userId={userIdNumber} />
      </div>
    </div>
  );
};

export default SalesClientDetailPage;
